function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 483.7",
    style: {
      enableBackground: "new 0 0 1920 483.7"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "line",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 5,
      strokeMiterlimit: 10,
      strokeDasharray: 2265,
      strokeDashoffset: -2265
    },
    d: "M1925.2,468.5c-1.7,0-645.2,0.2-645.3,0 c-3-28.8-27.5-51.2-57.1-51.2c-13,0-25,4.3-34.7,11.6c-6.6-5.3-15.1-8.5-24.2-8.5c-9.5,0-18.2,3.4-25,9.1 c-5.6-4.7-12.6-7.8-20.2-8.8c2.3-6.3,3.5-13.1,3.5-20.2c0-32.9-26.7-59.5-59.5-59.5c-5.9,0-11.7,0.9-17.1,2.5 c0.7-3.2,1.1-6.5,1.1-9.9c0-23.2-17.4-42.4-39.8-45.2c-4.8-7.2-11.6-12.9-19.6-16.4v-24.8c0-6.6-5.4-12-12-12h-0.6h-29.8h-0.6 c-6.6,0-12,5.4-12,12V272c-8,3.5-14.8,9.2-19.6,16.4c-22.4,2.8-39.8,22-39.8,45.2c0,3.4,0.4,6.7,1.1,9.9c-5.4-1.6-11.2-2.5-17.1-2.5 c-32.9,0-59.5,26.7-59.5,59.5c0,7.1,1.2,13.9,3.5,20.2c-7.6,0.9-14.6,4.1-20.2,8.8c-6.8-5.7-15.5-9.1-25-9.1 c-9.2,0-17.6,3.2-24.2,8.5c-9.6-7.3-21.7-11.6-34.7-11.6c-29.6,0-54,22.4-57.1,51.2H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rocket",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 5,
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "0 835",
      strokeDashoffset: -570
    },
    d: "M1036.2,182.4 c-1.3-20.6-14.9-37.2-32.1-41.3c-3.3-35.1-6.8-53.5-16.7-75.4c-9.6-21.3-25.9-42.1-27.6-44.2c-1.7,2.1-17.9,22.9-27.6,44.2 c-9.9,21.9-13.5,40.3-16.7,75.4c-17.2,4.1-30.7,20.6-32.1,41.3c-1,14.8,4.6,28.4,14,37.2c4.4-12.1,13-21.4,23.1-26.3 c-2.8-8.2-4.7-18-5.3-28.9c2.3,26.8,12.9,45.5,12.9,45.5H947l-14.7,25.5h55.2l-14.7-25.5h18.8c0,0,10.6-18.7,12.9-45.5 c-0.6,10.9-2.5,20.8-5.3,28.9c10.1,5,18.7,14.2,23.1,26.3C1031.6,210.8,1037.2,197.2,1036.2,182.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rocketCircle",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 5,
      strokeMiterlimit: 10,
      strokeDasharray: "0 130",
      strokeDashoffset: 65
    },
    cx: 959.7,
    cy: 122.2,
    r: 20
  }), /*#__PURE__*/React.createElement("line", {
    id: "rocketLine",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 5,
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: 60,
      strokeDashoffset: 60
    },
    x1: 931.1,
    y1: 68.4,
    x2: 988.9,
    y2: 68.4
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.383fae48.svg";
export { ForwardRef as ReactComponent };